<template>
  <div class="py-4 container-fluid">
    <div class="card mb-4">
      <div class="card-header">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col-md-8 text-left" style="padding-right: 150px;">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <button class="btn btn-sm tnkc-secondary dropdown-toggle border-0"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                          <i class="fa fa-search pr-2"></i>By : {{ key }}
                        </button>

                        <div class="dropdown-menu">
                          <a class="dropdown-item" href="#" @click="setKey('all')" :class="{'active':guestBookingParams.searchKey == 'all'}">All</a>
                          <a class="dropdown-item" href="#" @click="setKey('last_name')" :class="{'active':guestBookingParams.searchKey == 'last_name'}">LastName</a>
                          <a class="dropdown-item" href="#" @click="setKey('first_name')" :class="{'active':guestBookingParams.searchKey == 'first_name'}">FirstName</a>
                          <a class="dropdown-item" href="#" @click="setKey('middle_name')" :class="{'active':guestBookingParams.searchKey == 'middle_name'}">MiddleName</a>
                          <!--  <a class="dropdown-item" href="#" @click="setKey('rank')" :class="{'active':searchKey == 'rank'}">Rank</a>  -->
                        </div>
                      </div>

                      <input type="text"
                             id="guestValue"
                             class="form-control form-control"
                             v-model="guestBookingParams.searchValue"
                             v-on:input="searchGuest(1)"
                             :placeholder="keyPlaceHolder"
                             aria-label="Text input with dropdown button">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col col-lg-4">
                <select class="custom-select custom-select-sm w-50" id="displayCounts" v-model="guestBookingParams.count" v-on:change="setRecords">
                  <option v-for="count in displayCounts" :key="count" :value="count" :selected="count === guestBookingParams.count">
                    {{ count }} records
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body fs-13px">
        <div class="text-left">
          <small>
            {{ `${guestBookedPagination.from} - ${guestBookedPagination.to} of ${guestBookedPagination.total}` }}</small>
        </div>

        <nav aria-label="..." class="pt-0">
          <ul class="pagination pagination-sm">
            <li class="page-item" :class="{ 'disabled': guestBookedPagination.currentPage === 1}">
              <button class="page-link" @click="setPage(1)">
                <font-awesome-icon icon="step-backward"/>
                First
              </button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === guestBookedPagination.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': guestBookedPagination.currentPage === guestBookedPagination.lastPage}">
              <button class="page-link" @click="setPage(guestBookedPagination.lastPage)">
                Last
                <font-awesome-icon icon="step-forward"/>
              </button>
            </li>
          </ul>
        </nav>


        <div class="table-responsive-lg">
          <table class="table table-bordered p-0" width="100%" cellspacing="0">
            <thead>
            <tr class="bg-light">
              <th scope="col" class="p-1 text-center">
                <button class="btn btn-sm tnkc-secondary" v-on:click="searchGuest" data-toggle="tooltip" data-placement="top" data-html="true" title="Click to Refresh Data Table">
                  <font-awesome-icon icon="undo"/>
                </button>
              </th>
            </tr>
            <tr class="bg-light">
              <th scope="col" class="p-1 text-center" width="10">#</th>
              <th scope="col" class="p-1">Guest Name</th>
              <th scope="col" class="p-1">Company</th>
              <th scope="col" class="p-1">Floor—> Room—> Bed</th>
              <th scope="col" class="p-1">Check In</th>
              <th scope="col" class="p-1">Check Out</th>
              <th scope="col" class="p-1">Status</th>
              <th scope="col" class="p-1 vert-aligned">Action</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(guestBooking,index) in guestBookings" :key="index">
              <th scope="row" class="p-1 align-middle">{{ index + 1 }}</th>
              <td class="p-1 align-middle">
                <button class="btn btn-xsm text-left" v-on:click="viewGuestProfile" title="Click to view profile">
                  <u>{{ guestBooking.guestName.toUpperCase() }}</u>
                </button>
              </td>
              <td class="p-1 align-middle">{{ guestBooking.company }}</td>
              <td class="p-1 align-middle">{{ guestBooking.floor }}-> {{ guestBooking.room }}-> {{ guestBooking.bed }}
              </td>
              <td class="p-1 align-middle ">
                {{ guestBooking.booked_check_in | moment('D MMM YYYY') }}
              </td>

              <td class="p-1 align-middle">
                {{ guestBooking.booked_check_out | moment('D MMM YYYY') }}
              </td>

              <td class="p-1 align-middle">
                {{ guestBooking.status }}
              </td>

              <td class="p-1 align-middle vert-aligned">
                <button class="btn btn-xsm tnkc-primary"
                        data-toggle="modal"
                        data-target="#guestBookedModal"
                        data-backdrop="static"
                        data-keyboard="false"
                        v-on:click="guestBooked_dtls(guestBooking.id)">
                  <font-awesome-icon icon="eye" class="small"/>
                  <span class="ml-1 small">View</span>
                </button>

                <button class="btn btn-xsm tnkc-success ml-1" v-on:click="check_in(guestBooking.id)" v-show="!guestBooking.isCheckIn">
                  <font-awesome-icon icon="sign-in-alt" class="small"/>
                  <span class="ml-1 small">Check-In</span>
                </button>

                <button class="btn btn-xsm tnkc-danger ml-1" v-show="!guestBooking.isCheckIn" v-on:click="cancel_booking(guestBooking.id)">
                  Cancel
                </button>

                <div class="btn btn-xsm btn-group dropleft " v-show="!guestBooking.isCheckOut && guestBooking.isCheckIn">
                  <button type="button" class="btn btn-xsm tnkc-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="small"> Action</span>
                  </button>

                  <div class="dropdown-menu p-1 w-18">
                    <button class="btn btn-xsm tnkc-secondary dropdown-item text-left small" v-on:click="check_out(guestBooking.id)">
                      <font-awesome-icon icon="sign-out-alt" class="text-left mt-1 small"/>
                      <span class="ml-1 small">Check-Out</span>
                    </button>

                    <!--<button class="btn btn-xsm tnkc-danger dropdown-item text-left small mt-1">
                        <font-awesome-icon  icon="exchange-alt" class="text-left mt-1 small" v-on:click="transffer"/>
                        <span class="ml-1 small">Transfer</span>
                    </button>-->

                  </div>

                  <!--<button class="btn btn-xsm tnkc-danger ml-1">
                        <font-awesome-icon icon="ban" class="small"/>
                        <span class="ml-1 small">Cancel</span>
                    </button>-->

                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- guest booked dtls modal -->
    <div class="modal fade" id="guestBookedModal" tabindex="-1" role="dialog" aria-labelledby="guestBookedModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="guestBookedModalLabel">{{
                titleCase(guestBooking.guestName)
                                                                                }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <!--  -->
            <div class="row">
              <div class="col-md-6 text-left">
                <div class="form-group">
                  <label class="font-weight-bold">
                    <h5 class="font-weight-bold">
                      {{ titleCase(guestBooking.floor) }} —> {{ titleCase(guestBooking.room) }} —> {{
                        titleCase(guestBooking.bed)
                      }}
                    </h5>
                  </label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3 text-left">
                <div class="form-group">
                  <label for="bookedFrom" class="font-weight-bold">Date From :</label>
                  <input id="bookedFrom"
                         type="text"
                         aria-describedby="bookedFrom"
                         placeholder="Date From"
                         class="form-control form-control-sm"
                         v-model="guestBooking.booked_check_in"
                         :disabled="true">
                </div>
              </div>

              <div class="col-md-3 text-left">
                <div class="form-group">
                  <label for="bookedTo" class="font-weight-bold">Date To :</label>
                  <input id="bookedTo"
                         type="text"
                         aria-describedby="bookedTo"
                         placeholder="Date To"
                         :disabled="true"
                         :value="guestBooking.booked_check_out"
                         class="form-control form-control-sm">
                </div>
              </div>

              <div class="col-md-3 text-left">
                <div class="form-group">
                  <label for="checkIn" class="font-weight-bold">Check-In :</label>
                  <input id="checkIn"
                         type="text"
                         aria-describedby="checkIn"
                         placeholder="---"
                         :disabled="true"
                         v-model="guestBooking.check_in"
                         class="form-control form-control-sm">
                </div>
              </div>

              <div class="col-md-3 text-left">
                <div class="form-group">
                  <label for="checkIn" class="font-weight-bold">Check-Out :</label>
                  <input id="checkOut"
                         type="text"
                         aria-describedby="checkOut"
                         placeholder="---"
                         :disabled="true"
                         v-model="guestBooking.check_out"
                         class="form-control form-control-sm">
                </div>
              </div>
            </div>

            <div class="row">
              <!--                            <div class="col-md-3 text-left">-->
              <!--                                <div class="form-group">-->
              <!--                                    <label for="checkIn" class="font-weight-bold">Check-In</label>-->
              <!--                                    <input id="checkIn" type="text" aria-describedby="checkIn" placeholder="Check in"   class="form-control form-control-sm">-->
              <!--                                </div>-->
              <!--                            </div>-->
            </div>
          </div>

          <div class="modal-footer">
            <!--   <button class="btn btn-xsm tnkc-success">
                   <font-awesome-icon icon="save"/>
                   Save
               </button>-->

            <button type="button" class="btn btn-xsm tnkc-secondary" data-dismiss="modal" aria-label="Close">
              <font-awesome-icon icon="times"/>
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {appMixins} from '../../mixins/app.mixins';

export default {
  name: 'GuestBookingList',
  mixins: [appMixins],
  data() {
    return {
      key: '',
      keyPlaceHolder: '',
      displayCounts: [5, 10, 15, 20, 30, 50, 100, 200],
    };
  },

  methods: {
    ...mapActions(
        [
          'getAllGuestBooking',
          'getGuestBookedDetail',
          'setGuestBookedIn',
          'setGuestBookedOut',
           'deleteGuestBooked',
        ],
    ),

    //key
    setKey(obj) {
      this.guestBookingParams.searchKey = obj;
      this.searchGuest();
      this.searchBy();
    },

    //page
    setPage(page) {
      this.guestBookedPagination.currentPage = page;
      this.searchGuest();
    },

    setRecords(e) {
      this.guestBookingParams.count = parseInt(e.target.value, 10);
      this.searchGuest(1);
    },

    searchGuest(initPage = null) {
      //todo
      let page = (initPage) ? initPage : this.guestBookedPagination.currentPage;
      this.guestBookingParams.page = page;
      this.getAllGuestBooking(this.guestBookingParams);
    },

    searchBy() {
      switch (this.guestBookingParams.searchKey) {
        case 'all':
          this.key = 'All';
          this.keyPlaceHolder = 'Search here ...';
          break;

        case 'last_name':
          this.key = 'LastName';
          this.keyPlaceHolder = 'Search Last Name here ...';
          break;

        case 'first_name':
          this.key = 'FirstName';
          this.keyPlaceHolder = 'Search First Name here ...';
          break;

        case 'middle_name':
          this.key = 'MiddleName';
          this.keyPlaceHolder = 'Search Middle Name here ...';
          break;

        case 'crewipn':
          this.key = 'CrewIPN';
          this.keyPlaceHolder = 'Search CrewIPN here ...';
          break;

        case 'rank':
          this.key = 'Rank';
          this.keyPlaceHolder = 'Search CrewRank here ...';
          break;
      }
    },

    sortData(sortKey, orderBy) {
      //todo
    },

    //todo view the guest profile
    viewGuestProfile(id) {
      console.log(id);
    },

    guestBooked_dtls(id) {
      this.getGuestBookedDetail(id);
    },

    async check_in(guestBookedId) {
      if (await this.questionAlert('Are you sure you want to check in this guest?')) {
        this.setGuestBookedIn(guestBookedId).then((res) => {
          if (res == true) {
            this.successAlert('Check In Successfully.');
            this.searchGuest(1);
          }
        });
      }
    },

    async check_out(guestBookedId) {
      if (await this.questionAlert('Are you sure you want to check out this guest?')) {
        this.setGuestBookedOut(guestBookedId).then((res) => {
          if (res == true) {
            this.successAlert('Check out Successfully.');
            this.searchGuest(1);
          }
        });
      }
    },

   async cancel_booking(guestBookedId) {
     if(await this.questionAlert('Are you sure you want to cancel this record.','Cancel Booked')){
       this.deleteGuestBooked(guestBookedId).then((response)=>{
         if(response == true){
           this.successAlert('Cancelled Successfully');
         }
       });
     }
    },

    transffer() {
      console.log('transffer');
    },
  },

  computed: {
    ...mapGetters(['guestBookingParams', 'guestBookedPagination', 'guestBookings', 'guestBooking']),

    paginationPages() {
      let pages = [];
      let currentPage = this.guestBookedPagination.currentPage;
      let lastPage = this.guestBookedPagination.lastPage;
      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },

  },

  created() {
    this.searchBy();
    this.searchGuest();
  },

  mounted() {
    $(function() {
      $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover',
      });
    });
  },

  destroyed() {

  },

};
</script>

<style scoped>

u:hover,
u:focus {
  color: #2c82c9 !important;
  color: #4a4f54;
}


.btn-xsm, .btn-group-xsm > .btn {
  padding: 0.20rem 0.2rem !important;
  font-size: 0.870rem !important;
  line-height: 1 !important;
  border-radius: 0.25rem !important;
}

/* todo put all the style here. */
.fs-13px {
  font-size: 13px;
}

.table tbody > tr > td.vert-aligned {
  vertical-align: middle;
  padding: 0 !important;
}


input:disabled {
  background: white;
  border-bottom: 1px solid #cccccc;
  border-top: white;
  border-left: white;
  border-right: white;
}

</style>

<style>
.w-18 {
  width: 18% !important;
}

</style>
